import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { WorkpackService } from 'client/services';

const initialState = {
    draftWorkpack: null,
    createdWorkpack: null,
    loading: false,
    error: false,
    errorCode: 0,
    errorMessage: null
};

export const createWorkpack = createAsyncThunk('workpack/createWorkpack', async (payload, { rejectWithValue }) => {
    try {
        const response = await WorkpackService.createWorkpackRequest(payload);
        return response;
    } catch (err) {
        return rejectWithValue({ errorCode: err.errorCode ?? err.statusCode ?? 500, errorMessage: err.errorMessage ?? err.message ?? 'unknown' });
    }
});

export const workpackSlice = createSlice({
    name: 'workpack',
    initialState: { ...initialState },
    reducers: {
        clearDraftWorkpack: state => {
            return {
                ...state,
                draftWorkpack: null
            };
        },
        setDraftWorkpack: (state, action) => {
            const workpack = action?.payload;
            if (!workpack) {
                return;
            }
            return { ...state, draftWorkpack: action.payload };
        },
        clearCreatedWorkpack: state => {
            return {
                ...state,
                createdWorkpack: null,
                loading: false,
                error: false,
                errorCode: 0,
                errorMessage: null
            };
        }
    },
    extraReducers: {
        [createWorkpack.pending]: state => {
            return {
                ...state,
                loading: true,
                error: false,
                createdWorkpack: null
            };
        },
        [createWorkpack.fulfilled]: (state, action) => {
            const workpack = action.payload;
            if (workpack?.workpackReqId) {
                return {
                    ...state,
                    loading: false,
                    error: false,
                    createdWorkpack: workpack
                };
            } else {
                return {
                    ...state,
                    loading: false,
                    error: true,
                    createdWorkpack: null
                };
            }
        },
        [createWorkpack.rejected]: (state, action) => {
            return {
                ...state,
                loading: false,
                error: true,
                errorMessage: action.payload.errorMessage,
                errorCode: action.payload.errorCode,
                createdWorkpack: null
            };
        }
    }
});

export const {
    clearDraftWorkpack,
    setDraftWorkpack,
    clearCreatedWorkpack
} = workpackSlice.actions;

export default workpackSlice.reducer;
